// Integer-cents → dollars, for display.
//
// CONSUMER: internal-ui
//
// Shared rather than copied per page on purpose: three surfaces show
// the SAME ambassador fee (the ambassador's earnings, the admin ledger,
// the advisor's reduced-base panel), and three private copies of a
// money formatter is how the same number comes to read differently on
// two screens. Cents in, never dollars — the API sends integer cents
// end to end so no float rounding happens before display.

export function formatCents(cents: number | null | undefined): string {
  if (cents === null || cents === undefined || !Number.isFinite(cents)) return "—";
  return (cents / 100).toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  });
}

/** Basis points → a human percentage. 1500 → "15%", 1525 → "15.25%". */
export function formatBps(bps: number | null | undefined): string {
  if (bps === null || bps === undefined || !Number.isFinite(bps)) return "—";
  const pct = bps / 100;
  return `${Number.isInteger(pct) ? pct.toFixed(0) : pct.toFixed(2)}%`;
}
